import { differenceInYears, format, isValid, parse } from "date-fns";

const parseDateOfBirth = (value: string | null | undefined) => {
  if (!value) return null;

  const date = parse(value, "yyyy-MM-dd", new Date());

  return isValid(date) ? date : null;
};

export const formatDateOfBirth = (value: string | null | undefined) => {
  const date = parseDateOfBirth(value);

  return date ? format(date, "MM/dd/yyyy") : null;
};

export const getAge = (value: string | null | undefined) => {
  const date = parseDateOfBirth(value);

  return date ? differenceInYears(new Date(), date) : null;
};
